var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout__wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c(
          "div",
          { staticClass: "registry-form-container bg-white" },
          [
            _c("div", { staticClass: "checkout__stepnum" }, [
              _vm._v("\n                        1\n                    "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center w-100" }, [
              _c("h4", { staticClass: "checkout__column-title" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(
                      _vm.$translate(
                        "OD3dprimaV2::Template.checkoutInvoiceAddress"
                      )
                    ) +
                    "\n                        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.addressListOverridden
              ? [_vm._t("override-address-lists")]
              : [
                  _c(
                    "div",
                    { staticClass: "checkout__address" },
                    [_vm._t("invoice-address-select")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "checkout__address" },
                    [_vm._t("shipping-address-select")],
                    2
                  ),
                ],
            _vm._v(" "),
            [
              _c(
                "div",
                { staticClass: "checkout__wish" },
                [
                  _c("header", [
                    _c("h3", { staticClass: "checkout__your-address" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Ceres::Template.checkoutContactWish")
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("contact-wish-input", { staticClass: "pb-3" }),
                ],
                1
              ),
            ],
            _vm._v(" "),
            [
              _c(
                "div",
                { staticClass: "checkout__sign" },
                [
                  _c("header", [
                    _c("h3", { staticClass: "checkout__your-address" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Ceres::Template.checkoutCustomerSign")
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("customer-sign-input"),
                ],
                1
              ),
            ],
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c("div", { staticClass: "bg-white" }, [
          _c("div", { staticClass: "checkout__stepnum" }, [
            _vm._v("\n                        2\n                    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-center w-100" }, [
            _c("h4", { staticClass: "checkout__column-title" }, [
              _vm._v(
                "\n                            " +
                  _vm._s(
                    _vm.$translate(
                      "OD3dprimaV2::Template.checkoutPaymentShipping"
                    )
                  ) +
                  "\n                        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__column-sub-title" }, [
            _vm._v(
              "\n                        " +
                _vm._s(
                  _vm.$translate("Ceres::Template.checkoutPaymentMethod")
                ) +
                "\n                    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "checkout__payment" },
            [_vm._t("payment-provider-select")],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__column-sub-title" }, [
            _vm._v(
              "\n                        " +
                _vm._s(
                  _vm.$translate("Ceres::Template.checkoutShippingProfile")
                ) +
                "\n                    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "checkout__shipping" },
            [_vm._t("shipping-profile-select")],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c(
          "div",
          { staticClass: "bg-white" },
          [
            _c("div", { staticClass: "checkout__stepnum" }, [
              _vm._v("\n                        3\n                    "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center w-100" }, [
              _c("h4", { staticClass: "checkout__column-title" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(
                      _vm.$translate("OD3dprimaV2::Template.checkoutBasket")
                    ) +
                    "\n                        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sidebar" }, [
              _c("div", { staticClass: "cmp cmp-checkout-sidebar" }, [
                _c(
                  "div",
                  { staticClass: "cmp cmp-basket-preview-list" },
                  [_vm._t("basket-list")],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sidebar" }, [
              _c(
                "div",
                { staticClass: "cmp cmp-checkout-sidebar" },
                [_vm._t("totals")],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "checkout__shipping-check" },
              [_c("shipping-privacy-hint-check")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "checkout__privacy" },
              [_c("accept-gtc-check")],
              1
            ),
            _vm._v(" "),
            _vm._t("opt-ins"),
            _vm._v(" "),
            _vm._t("place-order", null, { showModal: _vm.showModal }),
            _vm._v(" "),
            _vm.initialCheckout.readOnly
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-block btn-outline-primary mt-3",
                    attrs: { href: _vm.urls.checkout + "?readonlyCheckout=0" },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-times",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.checkoutCancelCheckout"
                          )
                        ) +
                        "\n                    "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "checkoutModal",
        staticClass: "modal fade",
        attrs: { "data-backdrop": "static", "data-keyboard": "false" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", {
                ref: "checkoutModalContent",
                staticClass: "modal-body",
              }),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }